define( function() {
	"use strict";

	return ( /^$|^module$|\/(?:java|ecma)script/i );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/manipulation/var/rscriptType.js
// module id = 128
// module chunks = 0